import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useRequestActions, useGetRequestTypes } from 'support/hooks';
import { mapUpsertRequestForm } from 'support/mappers';
import { addSupportRequestJobsPath } from 'support/routes/routePaths';
import { IRequestForm } from 'support/types';
import { validateRequestedDate } from 'support/utils';

import { ApiStatuses, NotificationPosition } from 'coreOld/enums';
import { useNotification } from 'coreOld/hooks/useNotification';

import AddRequestFormView from './AddRequestFormView';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
}

const AddRequestForm = ({ isOpen, onClose }: IProps) => {
  const navigate = useNavigate();

  const { t } = useTranslation();
  const { clearModalNotification, showNotification } = useNotification();
  const { upsertRequest } = useRequestActions();

  const { records: requestTypes } = useGetRequestTypes();

  const onSubmit = () => async (data: IRequestForm) => {
    const { success, supportRequest } = await upsertRequest(mapUpsertRequestForm(data));

    if (!success) {
      return;
    }

    navigate(addSupportRequestJobsPath(), { state: { id: supportRequest.id } });
  };

  const onRequiredDateChange = (date: string) => {
    const showInfo = !validateRequestedDate(date);

    if (showInfo) {
      showNotification({
        message: t('errorRequestedDate2Days'),
        type: ApiStatuses.ERROR,
        position: NotificationPosition.MODAL,
      });
    }

    if (!showInfo) {
      clearModalNotification();
    }
  };

  return (
    <AddRequestFormView
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={onSubmit}
      onRequiredDateChange={onRequiredDateChange}
      requestTypes={requestTypes}
    />
  );
};

export default AddRequestForm;
